/** IssuesListRoute — skin-aware switcher for /issues. */
import { useUISkin } from "@/data/UISkinContext";
import IssuesList from "./IssuesList";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function IssuesListRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Operations · Issues" title="Issues">
        <IssuesList />
      </CockpitFrame>
    );
  }
  return <IssuesList />;
}
